export { SendingMethod } from '../../../../__generated__/globalTypes';
export type Step = 'PERSONAL_DATA' | 'VERIFIACTION' | 'LOGIN_AND_PASSWORD';
